import React from 'react';
import { Route, Routes } from 'react-router-dom';

import HeaderSecondary from '@components/HeaderSecondary';

import InsurancePolicyBuyNewPage from './InsurancePolicyBuyNewPage';
import InsurancePolicyBuyReviewPage from './InsurancePolicyBuyReviewPage';
import InsurancePolicyBuyEditPage from './InsurancePolicyBuyEditPage';
import InsurancePolicyBuyPayPage from './InsurancePolicyBuyPayPage';

const InsurancePolicyBuyRoute = () => {
  return (
    <>
      <HeaderSecondary />
      <Routes>
        <Route index element={<InsurancePolicyBuyNewPage />} />
        <Route path="/:insurancePolicyId/review" element={<InsurancePolicyBuyReviewPage />} />
        <Route path="/:insurancePolicyId/edit" element={<InsurancePolicyBuyEditPage />} />
        <Route path="/:insurancePolicyId/pay" element={<InsurancePolicyBuyPayPage />} />
      </Routes>
    </>
  );
};

export { InsurancePolicyBuyRoute };
